import { render } from "./ArchiveScreen.vue?vue&type=template&id=71f661cc&scoped=true"
import script from "./ArchiveScreen.vue?vue&type=script&lang=js"
export * from "./ArchiveScreen.vue?vue&type=script&lang=js"

import "./ArchiveScreen.vue?vue&type=style&index=0&id=71f661cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f661cc"]])

export default __exports__